import { apiPost, NO_RETRY } from "@/lib/api";
import type { LoginDTO, AuthApiResponse } from "@/types/authType";
import { UpdateMemberPasswordDTO } from "@/types/personnelType";

// Credentials required by the real /api/v1/Auth/Login endpoint.
const AUTH_ENV = {
  clientId: (import.meta.env?.VITE_BFP_MIMAROPA_CLIENT_ID as string | undefined) ?? "",
  clientSecret: (import.meta.env?.VITE_BFP_MIMAROPA_CLIENT_SECRET as string | undefined) ?? "",
  grantType: (import.meta.env?.VITE_BFP_MIMAROPA_GRANT_TYPE as string | undefined) ?? "PASSWORD",
  loginType:
    (import.meta.env?.VITE_BFP_MIMAROPA_LOGIN_TYPE as string | undefined) ?? "CDMS — BFP MIMAROPA",
};

export const authAPI = {
  async login(params: LoginDTO) {
    const body = {
      ...params,
      client_id: AUTH_ENV.clientId,
      client_secret: AUTH_ENV.clientSecret,
      grant_type: AUTH_ENV.grantType,
      login_type: AUTH_ENV.loginType,
    };
    return await apiPost<AuthApiResponse>("/api/v1/Auth/Login", body, {
      ...NO_RETRY,
      suppressGlobalLoading: true,
    });
  },

  async updatePassword(params: UpdateMemberPasswordDTO) {
    return await apiPost("/api/v1/Auth/Password/Update", params, { ...NO_RETRY });
  },
};
